import Main from '../../views/main'
import {ParentView} from '@/ladmin'

export default [
  {
    path: '/personPassControl',
    name: 'personPassControl',
    component: Main,
    meta: {
      disabled: true,
      label: '行人管控'
    },
    children: [
      {
        path: 'simulate',
        name: 'personSimulate',
        meta: {
          label: '通行模拟'
        },
        component: () => import('@/views/PersonPassControl/Simulate')
      },
      {
        path: 'passGroupList',
        name: 'personPassGroupList',
        meta: {
          label: '通行分组'
        },
        component: () => import('@/views/PersonPassControl/passGroupList')
      },
      {
        path: 'passGroupListParent',
        name: 'personPassGroupListParent',
        redirect: {name: 'personPassGroupList'},
        meta: {
          label: '通行分组'
        },
        component: ParentView,
        children: [
          {
            path: 'newPassGroup',
            name: 'PersonNewPassGroup',
            meta: {
              label: '新建通行分组'
            },
            component: () => import('@/views/PersonPassControl/passGroupForm')
          }
        ]
      },
    ]
  }
]
